import React, {Component} from "react";
import './ScheduledJobs.css';
import 'react-toastify/dist/ReactToastify.css';
import {linkJobToInstance} from "../../utils/utils"
import ScheduledJobsInfo from "../scheduledJobs/ScheduledJobs"


export default class ScheduledJobs extends Component {

    renderScheduledJobInfo = (scheduledJobs, requesting, searchTerm) => {
        if (!scheduledJobs || scheduledJobs.length === 0) {
            return (
                <>
                    {requesting ?
                        <div className={"loading-container"}>
                            Requesting...
                            <i className="fa fa-spinner fa-pulse fa-3x fa-fw"/>
                        </div>
                        :
                        <></>}
                </>);
        } else {
            const filteredJobs = this.filterJobsBySearch(searchTerm, scheduledJobs)
            return (
                <div>
                    {requesting ?
                        <div className={"loading-container"} data-testid="admin.loading.container">
                            Requesting...
                            <i className="fa fa-spinner fa-pulse fa-3x fa-fw"/>
                        </div>
                        :
                        <div>
                            <table className={"job-table"} data-testid="job.table">
                                <thead>
                                <tr className={"table-row"} data-testid="job.table.headerRow">
                                    <th className={"table-header-cell"} data-testid="job.table.headerCell.serviceName">Service Name</th>
                                    <th className={"table-header-cell"} data-testid="job.table.headerCell.email">Email</th>
                                    <th className={"table-header-cell"} data-testid="job.table.headerCell.job">Job</th>
                                    <th className={"table-header-cell"} data-testid="job.table.headerCell.status">Status</th>
                                    <th className={"table-header-cell"} data-testid="job.table.headerCell.createdDate">Created Date</th>
                                    <th className={"table-header-cell"} data-testid="job.table.headerCell.scheduledDate">Scheduled Date</th>
                                    <th className={"table-header-cell"} data-testid="job.table.headerCell.editJob">Edit Job</th>
                                </tr>
                                </thead>
                                {linkJobToInstance(this.props.pisaasInstances, filteredJobs).map((job, index) => {
                                    return (
                                        <ScheduledJobsInfo refresh={this.props.adminRefresh} job={job} key={index}/>
                                    )
                                })}
                            </table>
                        </div>
                    }
                </div>
            )
        }
    };

    filterJobsBySearch = (searchTerm, jobs) => {
        return jobs.filter((job) => job.description.includes(searchTerm) || job.email.includes(searchTerm) || job.status.includes(searchTerm) || job.service_name.includes(searchTerm))
    }

    render() {
        return (
            <div>
                {this.renderScheduledJobInfo(this.props.scheduledJobs, this.props.requestingScheduledJobs, this.props.searchTerm)}
            </div>
        );
    }
}
